import React, { useState } from 'react';
import { LayoutDashboard, Heart, FileText, Video, Calculator, Calendar, PlayCircle, Star, Download } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { MessageModal } from '../../components/modals/MessageModal';
export function VirtualToursPage() {
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    message: '',
    type: 'info' as 'success' | 'error' | 'info'
  });
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const handleRequestTour = () => {
    setModalContent({
      title: 'Tour Request Submitted',
      message: 'Your virtual tour request has been submitted. The property owner will contact you within 24 hours to confirm the schedule.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
  };
  const handleJoinCall = () => {
    setModalContent({
      title: 'Joining Virtual Tour',
      message: 'Opening Zoom meeting... In production, this would launch the video call platform.',
      type: 'info'
    });
    setIsMessageModalOpen(true);
  };
  const handleDownloadRecording = (plotName: string) => {
    setModalContent({
      title: 'Downloading Recording',
      message: `Downloading recording for ${plotName}. In production, this would download the video file.`,
      type: 'success'
    });
    setIsMessageModalOpen(true);
  };
  const handleSubmitFeedback = () => {
    if (rating === 0) {
      setModalContent({
        title: 'Rating Required',
        message: 'Please select a star rating before submitting feedback.',
        type: 'error'
      });
      setIsMessageModalOpen(true);
      return;
    }
    setModalContent({
      title: 'Feedback Submitted',
      message: 'Thank you for your feedback! This helps us improve our virtual tour experience.',
      type: 'success'
    });
    setIsMessageModalOpen(true);
    setRating(0);
    setFeedback('');
  };
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard/nri-buyer'
  }, {
    label: 'Shortlisted',
    icon: Heart,
    path: '/buyer/shortlisted'
  }, {
    label: 'POA & Legal',
    icon: FileText,
    path: '/nri/poa-legal'
  }, {
    label: 'Virtual Tours',
    icon: Video,
    path: '/nri/virtual-tours'
  }, {
    label: 'Tax & Forex',
    icon: Calculator,
    path: '/nri/tax-forex'
  }];
  return <DashboardLayout title="NRI Services" personaLabel="NRI MODE" personaColor="bg-purple-100 text-purple-800 border-purple-200" navItems={navItems} userInitials="NR" data-id="element-4977">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-4978">
        <div data-id="element-4979">
          <h1 className="text-2xl font-bold mb-1" data-id="element-4980">Virtual Site Visits</h1>
          <p className="text-gray-500 font-mono text-sm" data-id="element-4981">
            Inspect properties remotely via live video calls.
          </p>
        </div>
        <button onClick={handleRequestTour} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-4982">
          Request New Tour
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-4983">
        {/* Upcoming Tours */}
        <div className="lg:col-span-2 space-y-6" data-id="element-4984">
          <h2 className="font-bold text-lg" data-id="element-4985">Upcoming Scheduled Tours</h2>
          {[{
          plot: 'Premium Corner Plot - Hinjewadi',
          date: 'Tomorrow, 2:30 PM IST',
          agent: 'Rahul (Field Officer)',
          status: 'Confirmed'
        }, {
          plot: 'Lake View Plot - Whitefield',
          date: 'Oct 28, 11:00 AM IST',
          agent: 'Priya (Property Owner)',
          status: 'Pending'
        }].map((tour, i) => <div key={i} className="bg-white border border-gray-300 p-6 flex flex-col md:flex-row justify-between gap-4" data-id="element-4986">
              <div data-id="element-4987">
                <h3 className="font-bold text-[#1f2933] mb-1" data-id="element-4988">{tour.plot}</h3>
                <div className="flex items-center gap-2 text-sm text-gray-600 mb-2" data-id="element-4989">
                  <Calendar className="w-4 h-4" data-id="element-4990" /> {tour.date}
                </div>
                <p className="text-xs text-gray-500" data-id="element-4991">Host: {tour.agent}</p>
              </div>
              <div className="flex flex-col items-end gap-2" data-id="element-4992">
                <span className={`px-2 py-1 text-xs font-bold rounded border ${tour.status === 'Confirmed' ? 'bg-green-100 text-green-800 border-green-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-4993">
                  {tour.status.toUpperCase()}
                </span>
                {tour.status === 'Confirmed' && <button onClick={handleJoinCall} className="px-4 py-2 bg-blue-600 text-white text-sm font-bold hover:bg-blue-700" data-id="element-4994">
                    Join Call
                  </button>}
              </div>
            </div>)}

          <h2 className="font-bold text-lg mt-8" data-id="element-4995">Past Recordings</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4996">
            {[{
            name: 'Site Visit: Baner Plot',
            date: 'Oct 15, 2024'
          }, {
            name: 'Site Visit: Whitefield',
            date: 'Oct 10, 2024'
          }].map((recording, i) => <div key={i} className="bg-white border border-gray-300 p-4" data-id="element-4997">
                <div className="aspect-video bg-gray-100 border border-dashed border-gray-300 flex items-center justify-center mb-3 cursor-pointer hover:bg-gray-200" data-id="element-4998">
                  <PlayCircle className="w-10 h-10 text-gray-400" data-id="element-4999" />
                </div>
                <h3 className="font-bold text-sm mb-1" data-id="element-5000">{recording.name}</h3>
                <p className="text-xs text-gray-500 mb-3" data-id="element-5001">
                  Recorded on {recording.date}
                </p>
                <button onClick={() => handleDownloadRecording(recording.name)} className="text-blue-600 text-xs font-bold hover:underline flex items-center gap-1" data-id="element-5002">
                  <Download className="w-3 h-3" data-id="element-5003" /> Download Recording
                </button>
              </div>)}
          </div>
        </div>

        {/* Feedback Sidebar */}
        <div className="bg-white border border-gray-300 p-6 h-fit" data-id="element-5004">
          <h2 className="font-bold text-lg mb-4" data-id="element-5005">Tour Feedback</h2>
          <p className="text-sm text-gray-600 mb-4" data-id="element-5006">
            How was your last virtual tour experience?
          </p>
          <div className="flex gap-2 mb-4" data-id="element-5007">
            {[1, 2, 3, 4, 5].map(star => <button key={star} onClick={() => setRating(star)} className="transition-colors" data-id="element-5008">
                <Star className={`w-6 h-6 ${rating >= star ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-5009" />
              </button>)}
          </div>
          <textarea placeholder="Share your thoughts..." value={feedback} onChange={e => setFeedback(e.target.value)} className="w-full p-3 border border-gray-300 bg-gray-50 text-sm h-24 mb-4 focus:outline-none focus:border-gray-500" data-id="element-5010"></textarea>
          <button onClick={handleSubmitFeedback} className="w-full py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-5011">
            Submit Feedback
          </button>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title={modalContent.title} message={modalContent.message} type={modalContent.type} data-id="element-5012" />
    </DashboardLayout>;
}